import {
    ADD_PERMISSION_TO_TEAM,
    ADD_PERMISSION_TO_TEAM_FAIL,
    ADD_PERMISSION_TO_TEAM_SUCCESS,
    DELETE_PERMISSION_FROM_TEAM,
    DELETE_PERMISSION_FROM_TEAM_FAIL,
    DELETE_PERMISSION_FROM_TEAM_SUCCESS
} from './actionTypes';

export const addPermissionToTeam = ({ teamId, permission }) => ({
    type: ADD_PERMISSION_TO_TEAM,
    payload: { teamId, permission }
});

export const addPermissionToTeamSuccess = team => ({
    type: ADD_PERMISSION_TO_TEAM_SUCCESS,
    payload: team
});

export const addPermissionToTeamFail = error => ({
    type: ADD_PERMISSION_TO_TEAM_FAIL,
    payload: error
});

export const deletePermissionFromTeam = ({ teamId, permission }) => ({
    type: DELETE_PERMISSION_FROM_TEAM,
    payload: { teamId, permission }
});

export const deletePermissionFromTeamSuccess = team => ({
    type: DELETE_PERMISSION_FROM_TEAM_SUCCESS,
    payload: team
});

export const deletePermissionFromTeamFail = error => ({
    type: DELETE_PERMISSION_FROM_TEAM_FAIL,
    payload: error
});
